import { useForm } from 'domains/forms/hooks'
import { className } from 'lib/css'

function Form({
  className: givenClassName,
  disableValidationClasses = false,
  ...props
}) {
  const { handleSubmit, isValid, isSubmitted } = useForm()

  const formClasses = ['form']

  if (!disableValidationClasses && isSubmitted) {
    formClasses.push('form--submitted')

    if (isValid) {
      formClasses.push('form--valid')
    } else {
      formClasses.push('form--invalid')
    }
  }

  return (
    <form
      onSubmit={handleSubmit}
      className={className([...formClasses, givenClassName])}
      {...props}
    />
  )
}

export default Form
